export enum LicenseModel {
	subscription,
	flex,
}
